/**
 * Map a free-text menu item name (or category as fallback) to a Phosphor icon
 * name + a complementary tint. Used by the Admin Menu bulk-import so admins
 * never have to choose icons — they're picked automatically from the item
 * name's keywords. Falls back to a generic ForkKnife icon if nothing matches.
 *
 * Keep the keyword list short and obvious; this is not meant to be perfect,
 * only good enough so the menu doesn't look like a wall of identical icons.
 */

// Ordered: more specific terms first.
const RULES = [
    // Beverages
    { kw: ["espresso", "cappuccino", "latte", "mocha", "americano", "coffee"], icon: "Coffee", color: "#7C2D12" },
    { kw: ["chai", "tea"], icon: "Coffee", color: "#A16207" },
    { kw: ["juice", "smoothie", "lassi", "shake", "milkshake"], icon: "Orange", color: "#EA580C" },
    { kw: ["water", "bottle", "soda", "coke", "pepsi", "cola"], icon: "Drop", color: "#0EA5E9" },
    { kw: ["beer", "wine", "cocktail", "mocktail"], icon: "Wine", color: "#7C3AED" },

    // Mains
    { kw: ["pizza"], icon: "Pizza", color: "#DC2626" },
    { kw: ["burger", "patty"], icon: "Hamburger", color: "#B45309" },
    { kw: ["sandwich", "sub", "panini", "toast"], icon: "Sandwich", color: "#B45309" },
    { kw: ["wrap", "roll", "kati"], icon: "Sandwich", color: "#92400E" },
    { kw: ["pasta", "noodle", "spaghetti", "maggi", "ramen"], icon: "BowlFood", color: "#D97706" },
    { kw: ["rice", "biryani", "biriyani", "pulao", "fried rice", "khichdi"], icon: "BowlFood", color: "#B45309" },
    { kw: ["curry", "dal", "sambar", "rasam", "gravy", "masala"], icon: "BowlFood", color: "#B45309" },
    { kw: ["roti", "naan", "paratha", "bread", "chapati"], icon: "Bread", color: "#92400E" },
    { kw: ["dosa", "idli", "vada", "uttapam"], icon: "BowlFood", color: "#B45309" },

    // Proteins
    { kw: ["chicken", "tikka", "tandoori"], icon: "Hamburger", color: "#B91C1C" },
    { kw: ["fish", "prawn", "shrimp", "seafood"], icon: "Fish", color: "#0284C7" },
    { kw: ["egg", "omelet", "omelette", "scramble"], icon: "Egg", color: "#CA8A04" },
    { kw: ["paneer", "tofu"], icon: "BowlFood", color: "#B45309" },

    // Sides / Snacks
    { kw: ["salad", "veggie", "greens"], icon: "Carrot", color: "#65A30D" },
    { kw: ["soup"], icon: "BowlFood", color: "#B45309" },
    { kw: ["fries", "chips", "wafer"], icon: "ForkKnife", color: "#CA8A04" },
    { kw: ["samosa", "pakora", "bhajiya", "kachori"], icon: "ForkKnife", color: "#D97706" },
    { kw: ["cookie", "biscuit"], icon: "Cookie", color: "#92400E" },
    { kw: ["cake", "pastry", "muffin", "donut", "doughnut", "cupcake", "brownie"], icon: "Cake", color: "#DB2777" },
    { kw: ["ice cream", "icecream", "kulfi", "gelato"], icon: "IceCream", color: "#DB2777" },
    { kw: ["chocolate"], icon: "Cookie", color: "#7C2D12" },
    { kw: ["fruit", "apple", "banana", "mango"], icon: "Apple", color: "#DC2626" },
];

// Per-category fallback when the item name yields no specific match.
const CATEGORY_FALLBACK = {
    beverages: { icon: "Coffee", color: "#A16207" },
    drinks: { icon: "Coffee", color: "#A16207" },
    snacks: { icon: "Cookie", color: "#65A30D" },
    breakfast: { icon: "Bread", color: "#D97706" },
    lunch: { icon: "BowlFood", color: "#B45309" },
    dinner: { icon: "BowlFood", color: "#7C3AED" },
    dessert: { icon: "Cake", color: "#DB2777" },
    desserts: { icon: "Cake", color: "#DB2777" },
    sweets: { icon: "Cake", color: "#DB2777" },
};

export function guessMenuIcon(name = "", category = "") {
    const haystack = `${name} ${category}`.toLowerCase();
    for (const rule of RULES) {
        if (rule.kw.some((k) => haystack.includes(k))) {
            return { icon: rule.icon, color: rule.color };
        }
    }
    const catKey = (category || "").trim().toLowerCase();
    if (CATEGORY_FALLBACK[catKey]) return CATEGORY_FALLBACK[catKey];
    return { icon: "ForkKnife", color: "#B45309" };
}
